import { useCollaborativeStateDetailsQuery, useStateExhibitTemplateQuery } from '@uplift/queries';

import { canResolveRejectionWithStateExhibit } from './utils';

export const useCanResolveRejectionWithStateExhibit = (
  providerId: string,
  licenseId: string,
  stateId: string,
  allowsStateExhibit: boolean,
): boolean => {
  const { data: collaborativeStateDetails } = useCollaborativeStateDetailsQuery(stateId);
  const { data: exhibitTemplate } = useStateExhibitTemplateQuery(providerId, licenseId);

  return canResolveRejectionWithStateExhibit({
    allowsStateExhibit,
    authorizationRequirement: collaborativeStateDetails?.authorizationRequirement,
    hasActiveExhibitTemplate: !!exhibitTemplate,
  });
};
